// auto-generated by Typewriter template _models.tst from PortCall.Models\VesselResult\DataSetVersion.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// DataSetVersionData is the class that DataSetVersion serializes to/from
export interface DataSetVersionData {
	
	
    Value : string | null;
}

// DataSetVersionOptions is the class which may be passed to the DataSetVersion constructor to define optional initial data values
export interface DataSetVersionOptions {
	
	
    Value? : string | null;
}

export class DataSetVersion {
	
	
    public Value : DataSignal<string | null>;

    constructor();
    constructor(data : DataSetVersionOptions);
    constructor(data: DataSetVersionOptions | null = null) {
	    
	    
        this.Value = jsonableObservable(S.value<string | null>(data && data.Value !== undefined ? data.Value : null));
    }

    static key(obj : DataSetVersion) {
        return ;
    }
    
    static dataKey(obj : DataSetVersionOptions) {
        return ;
    }

    static update(obj : DataSetVersion, data : DataSetVersionOptions) {
        S.freeze(() => {
	        
	        
            if (data.Value !== undefined) obj.Value(data.Value);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/DataSetVersion.ts